import React from 'react';
import Product from './Product';

function ProductList({ products, increment, decrement}) {
  // console.log('products', products)
  return (
    <>
      {products.map((_product, index) => {
        if (_product.extra === 'COMBO_ONLY') return null
        return (
          <Product
            key={index}
            {..._product}
            increment={increment}
            decrement={decrement}
            // isProduct={true}
            isProduct={!_product?.products} // combo ha una proprietà products
          />
        );
      })}
    </>
  );
}

export default ProductList;
